import React from "react";
import "./style.css";
import MissionImg from "../../../assets/img/banner/baby.jpeg";
import MissionImg2 from "../../../assets/img/banner/WhatsApp Image 2026-02-17 at 5.29.03 AM (2).jpeg";

const Mission = () => {
  return (
    <section className="mission_section prolove-section">
      <div className="container">
        <div className="row align-items-center prolove-row">
          <div className="col-lg-4 col-md-12 who_we_are_img_col hide">
            <div
              className="prolove-img-stack"
              style={{ marginBottom: "20%", marginLeft: "25%" }}
            >
              <img
                src={MissionImg}
                alt="Pro-Love"
                className="prolove-img prolove-img-top"
              />
              <img
                src={MissionImg2}
                alt="Pro-Love"
                className="prolove-img prolove-img-bottom"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 prolove-text-col">
            <div className="prolove-content">
              {/* <div className="col-lg-4 col-md-12 who_we_are_img_col">
                        <div className="who_we_are_img">
                            <img
                                src={MissionImg}
                                alt="Cradle Care Foundation"
                                className="img-fluid"
                            />
                        </div>
                    </div> */}
              {/* 
                        <div className="mobile-prolove-img">
                        <img
                            src={MissionImg}
                            alt="Pro-Love"
                            className="prolove-img prolove-img-top"
                        />
                        <img
                            src={MissionImg2}
                            alt="Pro-Love"
                            className="prolove-img prolove-img-bottom"
                        />
                    </div> */}
              <h2 className="who_we_are_heading">Our Mission</h2>
              <div className="who_we_are_subheading">
                Empowering Expectant Mothers with Care, Support, and Love
              </div>
              <p className="prolove-paragraph">
                We walk alongside pregnant women—especially young adults and
                single mothers—offering holistic support through:
              </p>
              <ul
                className="prolove-list prolove-paragraph"
                style={{ marginTop: "-4%" }}
              >
                <li>- Education</li>
                <li>- Emotional and Social Support</li>
                <li>- Practical Assistance</li>
                <li>- Spiritual Guidance rooted in Christ’s love</li>
              </ul>
              <p className="prolove-paragraph">
                Our goal is to ensure moms feel seen, heard, and valued
                throughout her motherhood journey.
              </p>
              {/* <button className="prolove-btn">Start a Group</button> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-12 prolove-img-col hide2">
            <div className="prolove-img-stack-desktop">
              <img
                src={MissionImg}
                alt="Pro-Love"
                className="prolove-img prolove-img-top-desktop"
              />
              <img
                src={MissionImg2}
                alt="Pro-Love"
                className="prolove-img prolove-img-bottom-desktop"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Mission;
